import { MAP_TYPES } from '@deck.gl/carto';

const TRACT_SOCIOECONOMIC_SOURCE_ID = 'tractSocioeconomicSource';

function source(year, socioeconomicFactor) {
  year = parseInt(year);

  return {
    id: TRACT_SOCIOECONOMIC_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data: `
      SELECT
        ST_X(ST_CENTROID(geom)) AS lng, ST_Y(ST_CENTROID(geom)) AS lat, year, ${socioeconomicFactor}, tractcode
      FROM
        carto-dw-ac-cn5bemsi.shared.tract_observations AS observations
      JOIN
        carto-dw-ac-cn5bemsi.shared.tracts AS tracts ON tracts.geoid = observations.geoid
      JOIN
        carto-dw-ac-cn5bemsi.shared.tract_geometries AS geometry ON observations.geoid = geometry.geoid
      WHERE
        observations.year = ${year}
    `,
    queryParameters: {
      year,
      socioeconomicFactor,
    },
  };
}

export default source;
